import { httpRequest } from "../../http";
export class CommandObjectiveDelete {
  async run(engagementId: number, objectiveId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/objectives/${objectiveId}/`
    try {
      const response = await httpRequest<any>(url, { method: "DELETE" })
      return response
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }

  // deserialize(data: any) : EngagementsPage{
  //     const serializer = new EngagementListSerializer();
  //     return serializer.deserialize(data);
  // }
}

